export interface Location {
  id: number;
  name: string;
  address: string;
  poi_id: number;
  latitude: number;
  longitude: number;
  radius: number;
  zipcode: string;
  street: string;
  preceptivity_disabled: boolean;
  location_type: string;
  state: string;
  city: string;
  dma: string;
  congressional_district: string;
  variables: string[];
  excluded?: boolean;
  bounded_by: string;
}

export interface HeadCell {
  id: keyof Location;
  numeric: boolean;
  label: string;
}

export const headCells: readonly HeadCell[] = [
  {
    id: 'name',
    numeric: false,
    label: 'Location Name',
  },
  {
    id: 'address',
    numeric: false,
    label: 'Address',
  },
  {
    id: 'poi_id',
    numeric: true,
    label: 'POI ID',
  },
  {
    id: 'latitude',
    numeric: true,
    label: 'Latitude',
  },
  {
    id: 'longitude',
    numeric: true,
    label: 'Longitude',
  },
  {
    id: 'radius',
    numeric: true,
    label: 'Radius',
  },
  {
    id: 'zipcode',
    numeric: false,
    label: 'Zipcode',
  },
  {
    id: 'street',
    numeric: false,
    label: 'Street',
  },
  {
    id: 'preceptivity_disabled',
    numeric: false,
    label: 'Preceptivity Disabled',
  },
  {
    id: 'state',
    numeric: false,
    label: 'State',
  },
  {
    id: 'city',
    numeric: false,
    label: 'City',
  },
  {
    id: 'dma',
    numeric: false,
    label: 'Dma',
  },
  {
    id: 'congressional_district',
    numeric: false,
    label: 'Cong. District',
  },
  {
    id: 'variables',
    numeric: false,
    label: 'Variables',
  },
];

export const draftLocation = {
  address: '',
  city: '',
  congressional_district: '',
  dma: '',
  id: '',
  latitude: undefined,
  preceptivity_disabled: false,
  location_type: '',
  longitude: undefined,
  name: '',
  poi_id: undefined,
  radius: undefined,
  state: '',
  street: '',
  variables: [],
  zipcode: '',
  excluded: false,
  bounded_by: null,
};
